"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    SimpleMarkdownElement: ()=>SimpleMarkdownElement
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_InlineLocationLink_js_namespaceObject = require("./InlineLocationLink.js");
const external_InlineCitationLink_js_namespaceObject = require("./InlineCitationLink.js");
const SimpleMarkdownElement = (props)=>{
    const { element, setLineMarginLeft, handleMapButtonClick, pinsInCurrentLine } = props;
    if ('object' != typeof element) return null;
    if ('HEADER' === element.elementType) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
        bold: true,
        children: element.content
    });
    const startOfTheListItem = 'LIST_ITEM' === element.containerType && element.newLineStart;
    if (startOfTheListItem) setLineMarginLeft(3);
    if ('TEXT' === element.elementType) {
        const isbold = 'bold' === element.style;
        const fontStyle = 'italic' === element.style ? 'italic' : '';
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text.span, {
            bold: isbold,
            fontStyle: fontStyle,
            children: [
                startOfTheListItem && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                    children: " - "
                }),
                element.content
            ]
        });
    }
    if ('LINK' === element.elementType) {
        const metadata = element.metadata;
        if (metadata && 'CITATION' === metadata.type) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
            children: [
                startOfTheListItem && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                    children: " - "
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_InlineCitationLink_js_namespaceObject.InlineCitationLink, {
                    metadata: metadata
                })
            ]
        });
        if (metadata && metadata.type) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
            children: [
                startOfTheListItem && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                    children: " - "
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_InlineLocationLink_js_namespaceObject.InlineLocationLink, {
                    metadata: metadata,
                    handleMapButtonClick: handleMapButtonClick,
                    pinsInCurrentLine: pinsInCurrentLine
                })
            ]
        });
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Link, {
            href: element.URL,
            target: "_blank",
            children: [
                startOfTheListItem && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                    children: " - "
                }),
                element.content
            ]
        });
    }
    if ('IMAGE' === element.elementType) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Image, {
        src: element.URL,
        alt: element.content,
        style: {
            display: 'inline-block',
            marginRight: '8px'
        },
        borderRadius: "xl",
        width: "120px",
        height: "90px"
    });
    if ('HORIZONTAL_RULE' === element.elementType) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
        mb: 1,
        children: "---"
    });
    return null;
};
exports.SimpleMarkdownElement = __webpack_exports__.SimpleMarkdownElement;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "SimpleMarkdownElement"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
